import {
  Component,
  EventEmitter,
  Output,
  forwardRef,
  OnInit,
  ElementRef,
  Input
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgxsOnInit } from '@ngxs/store';
import { AbstractField } from './abstract-field.component';

const customValueProvider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => NumberFieldComponent),
  multi: true
};

@Component({
  selector: 'number-field',
  inputs: [...AbstractField.inputs, 'min'],
  outputs: [...AbstractField.outputs],
  template: `
    <div
      [floatingLabel]="model"
      [focus]="focused"
      [ngClass]="{
        'validation-failed':
          (showValidation || inp.dirty || inp.touched) &&
          required &&
          (!model || model == '' || !inp.valid)
      }"
    >
      <label for="FIELD={{ id }}">{{ label + (required ? '*' : '') }}</label>
      <input
        [autocomplete]="autocomplete"
        [attr.name]="autocomplete"
        id="FIELD-{{ id }}"
        [(ngModel)]="model"
        [placeholder]="label + (required ? ' *' : '')"
        class="form-control"
        (focus)="focused = true"
        (blur)="onBlur($event)"
        (ngModelChange)="onChange($event)"
        [disabled]="disabled"
        [required]="required"
        #inp="ngModel"
        type="number"
        [min]="min"
      />
    </div>
  `,
  providers: [customValueProvider]
})
export class NumberFieldComponent extends AbstractField {
  min;
  constructor() {
    super();
  }
}
